<app-chip-button (click)="openDialog()" [noBorder]="true" backgroundColor="primary" [minWidth]="'32%'" >
  <div class="d-flex align-items-center justify-content-between">
    Download Whitepaper
    <img src="assets/images/icon-arrow-right.svg">
  </div>
</app-chip-button>